<template>
  <div class="animation-container">
    <BackgroundClouds :showQuote="moveDown"/>
    <AnimatedHands :initialClose="moveDown" :style="{ pointerEvents: 'none' }"/>
    <div class="heart" :class="{ 'show-heart': showHeart, 'move-down': moveDown }">
      <div v-if="prodName === 'Accompania'">
          <button
          v-for="(part, index) in accHeartParts" 
          :key="index"
          :class="`heart-part-ac-${index}`"
          >
              <img 
              :src="part.src"
              :class="['heart-part', `heart-part-${index}`, { gray: !isProductComplete(productMap[index]) }]"
              @click="startCustomization(productMap[index])"
              :style="part.style">
          </button>
        </div>

      <div v-else-if="prodName === 'Artistico'">
          <button
          v-for="(part, index) in artHeartParts"
          :key="index"
          :class="`heart-part-art-${index}`">
            <img 
              :src="part.src"
              :class="['heart-part', `heart-part-${index}`, { gray: !isProductComplete(productMap[index]) } ]"
              @click="startCustomization(productMap[index])"
              :style="part.style">
          </button>
      </div>

      <div v-else-if="prodName === 'Everlast'">
        <button
        v-for="(part, index) in evHeartParts"
        :key="index"
        :class="`heart-part-ev-${index}`">
          <img
            :src="part.src"
            :class="['heart-part', `heart-part-${index}`, { gray: !isProductComplete(productMap[index]) }]"
            @click="startCustomization(productMap[index])"
            :style="part.style">
        </button>
      </div>
      <div class="next-button-container">
        <button :disabled="moveDown" @click="startAnimation">Next</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import BackgroundClouds from './BackgroundClouds.vue'
import AnimatedHands from './AnimatedHands.vue'
import acc_heart1 from '../../assets/images/heart_animations/hearts/Heart1.png'
import acc_heart2 from '../../assets/images/heart_animations/hearts/Heart2.png'
import acc_heart3 from '../../assets/images/heart_animations/hearts/Heart3.png'
import acc_heart4 from '../../assets/images/heart_animations/hearts/Heart4.png'
import acc_heart5 from '../../assets/images/heart_animations/hearts/Heart5.png'
import acc_heart6 from '../../assets/images/heart_animations/hearts/Heart6.png'

import art_heart1 from '../../assets/images/heart_animations/hearts/Artistico_5/A1.png'
  import art_heart2 from '../../assets/images/heart_animations/hearts/Artistico_5/A2.png'
  import art_heart3 from '../../assets/images/heart_animations/hearts/Artistico_5/A3.png'
  import art_heart4 from '../../assets/images/heart_animations/hearts/Artistico_5/A4.png'
  import art_heart5 from '../../assets/images/heart_animations/hearts/Artistico_5/A5.png'

  import ev_heart1 from '../../assets/images/heart_animations/hearts/Everlast_4/H1.png'
import ev_heart2 from '../../assets/images/heart_animations/hearts/Everlast_4/H2.png'
import ev_heart3 from '../../assets/images/heart_animations/hearts/Everlast_4/H3.png'
import ev_heart4 from '../../assets/images/heart_animations/hearts/Everlast_4/H4.png'

const props = defineProps({
  prodName: {
    type: String,
    required: true,
  },
  personalizationSet: {
    type: Array
  },
  startCustomization: {
    type: Function
  },
  nextStep: {
    type: Function
  },
  nextPage: {
    type: Function
  },
})

const showHeart = ref(false)
const moveDown = ref(false)
const accHeartParts = ref([
  { 
    src: acc_heart1, 
    style: { 
      animationDelay: '0s',
      left: '54%',
      top: '41%',
      width: '260px'
    } 
  },
  { 
    src: acc_heart2, 
    style: { 
      animationDelay: '0.2s',
      left: '28%',
      top: '26.5%',
      width: '350px'
    } 
  },
  { 
    src: acc_heart3, 
    style: { 
      animationDelay: '0.4s',
      left: '64%',
      top: '3%',
      width: '290px'
    } 
  },
  { 
    src: acc_heart4, 
    style: { 
      animationDelay: '0.6s',
      left: '74%',
      top: '17%',
      width: '210px'
    } 
  },
  { 
    src: acc_heart5, 
    style: { 
      animationDelay: '0.8s',
      left: '90%',
      top: '0%',
      width: '260px'
    } 
  },
  { 
    src: acc_heart6, 
    style: { 
      animationDelay: '1.0s',
      left: '27%',
      top: '4%',
      width: '260px'
    } 
  }
])

const artHeartParts = ref([
    { 
      src: art_heart1, 
      style: { 
        animationDelay: '0s',
        left: '52%',
        top: '46%',
        width: '320px'
      } 
    },
    { 
      src: art_heart2, 
      style: { 
        animationDelay: '0.2s',
        left: '79%',
        top: '4%',
        width: '230px'
      } 
    },
    { 
      src: art_heart3, 
      style: { 
        animationDelay: '0.4s',
        left: '64%',
        top: '9%',
        width: '260px'
      } 
    },
    { 
      src: art_heart4, 
      style: { 
        animationDelay: '0.6s',
        left: '31%',
        top: '22%',
        width: '230px'
      } 
    },
    { 
      src: art_heart5, 
      style: { 
        animationDelay: '0.8s',
        left: '33%',
        top: '5%',
        width: '200px'
      } 
    }
  ])

  const evHeartParts = ref([
  { 
    src: ev_heart1, 
    style: { 
      animationDelay: '0s',
      left: '43%',
      top: '40%',
      width: '310px'
    } 
  },
  { 
    src: ev_heart2, 
    style: { 
      animationDelay: '0.2s',
      left: '75%',
      top: '10%',
      width: '350px'
    } 
  },
  { 
    src: ev_heart3, 
    style: { 
      animationDelay: '0.4s',
      left: '60%',
      top: '17%',
      width: '260px'
    } 
  },
  { 
    src: ev_heart4, 
    style: { 
      animationDelay: '0.6s',
      left: '29%',
      top: '10%',
      width: '230px'
    } 
  }
])
onMounted(() => {
  setTimeout(() => {
    showHeart.value = true
  }, 500)
})
const startAnimation = () => {
  if (props.nextStep && !props.nextStep()) {
    return;
  }
  moveDown.value = true
  setTimeout(() => {
    if (props.nextPage) {
      props.nextPage()
    }
  }, 3000)

  // setTimeout(() => {
  //   moveDown.value = true
  // }, 2500)
}
const productMap = computed(() => {
  switch (props.prodName) {
    case 'Accompania':
      return [5, 0, 4, 2, 3, 1];
    case 'Artistico':
      return [4, 3, 1, 2, 0];
    case 'Everlast':
      return [1, 0, 3, 2];
    default:
      return [];
  }
});

// Safe check for product completion status
const isProductComplete = (productIndex) => {
  if (!props.personalizationSet || !Array.isArray(props.personalizationSet)) {
    return false;
  }
  const product = props.personalizationSet[productIndex];
  if (!product) {
    return false;
  }
  return product.isComplete === true;
};
</script>

<style scoped>
.animation-container {
  width: 100vw;
  height: 85vh;
  min-height: 350px;
  position: relative;
  overflow: hidden;
  background: url('../../assets/images/heart_animations/Background.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.heart {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 70%;
  transform: translate(-50%, -50%);
  width: 560px;
  height: 560px;
  transition: transform 1s ease-in-out;
  opacity: 0;
}

@media (max-width: 768px) {
  .heart {
    width: 450px;
    height: 450px;
    top: 75%;
  }
  .heart-part {
    transform: translate(-50%, -50%) scale(0.75) !important;
  }
  .move-down {
    transform: translate(-50%, -10%) !important;
  }
}

@media (max-width: 480px) {
  .heart {
    width: 350px;
    height: 350px;
    top: 80%;
  }
  .heart-part {
    transform: translate(-50%, -50%) scale(0.6) !important;
  }
  .move-down {
    transform: translate(-50%, -5%) !important;
  }
}

.heart-part {
  position: absolute;
  opacity: 0;
  transform: translate(-50%, -50%);
}

.heart-part-ac-0 img{
  clip-path: polygon(51.54% 14.68%, 75% 14.68%, 93.83% 28.68%, 98.08% 38.08%, 75% 48.51%, 61.21% 63.03%, 41.14% 84.18%, 36.22% 94.26%, 0% 61.54%, 21.2% 38.08%);
}

.heart-part-ac-1 img{
  clip-path: polygon(36.76% 66.81%, 13.71% 39.71%, 13.71% 25%, 85% 32.14%, 85% 48.8%, 54.33% 78.8%);
}

.heart-part-ac-2 img{
  clip-path: polygon(33.97% 25%, 53.38% 18.38%, 80.52% 9.14%, 75% 29.2%, 75% 50%, 46.55% 69.62%, 25% 90.61%, 16.03% 61.9%, 22.35% 42.16%);
}

.heart-part-ac-3 img{
  clip-path: polygon(32.24% 29.04%, 58.84% 11.49%, 74.58% 18.11%, 82.59% 50.56%, 90.81% 66.78%, 72.98% 83.07%, 58.84% 83.07%, 30.71% 74.99%, 3.29% 64.74%, 11.14% 48.05%);
}

.heart-part-ac-4 img{
  clip-path: polygon(26.53% 26.25%, 32.24% 10.24%, 49.13% 12.25%, 66.44% 22.43%, 74.3% 51.95%, 69.78% 69.5%, 61% 87.67%, 46.66% 95.04%, 41.7% 74.48%, 37.28% 60.43%, 28.86% 53.44%, 25.04% 43.19%);
}
.heart-part-ac-5 img{
  clip-path: polygon(25% 25%, 43.91% 19.51%, 63.61% 19.51%, 91.15% 35.38%, 97.31% 45.77%, 91.15% 74.62%, 38.85% 74.62%, 5.38% 65.38%, 5.38% 49.62%);
}


.heart-part-art-0 img{
  clip-path: polygon(12.81% 31.25%, 27.24% 15.63%, 51.44% 7.93%, 69.06% 11.25%, 92.28% 15.63%, 86.45% 26.46%, 75.13% 31.25%, 56.3% 44.81%, 32.19% 64.38%, 27.24% 51.51%);
}

.heart-part-art-1 img{
  clip-path: polygon(19.67% 25.28%, 25.43% 8.7%, 52.25% 4.55%, 79.39% 19.32%, 83.04% 50%, 79.39% 72.24%, 65.56% 90.03%, 47.81% 90.03%, 25.43% 68.48%);
}

.heart-part-art-2 img{
  clip-path: polygon(20.26% 30.88%, 34.27% 12.37%, 57.78% 1.98%, 60.64% 17.78%, 73.22% 64.53%, 95.85% 75.94%, 90.16% 87.22%, 55.77% 80.73%, 25.33% 80.73%, 12.17% 72.51%, 15.83% 53.67%);
}

.heart-part-art-3 img{
  clip-path: polygon(11.09% 3.7%, 41.11% 19.63%, 71.96% 33.91%, 100% 50.87%, 59.24% 72.29%, 46.51% 85.26%, 31.52% 75%, 19.06% 61.78%, 6.52% 33.91%);
}

.heart-part-art-4 img{
  clip-path: polygon(25% 25%, 54.54% 16.37%, 75% 25%, 90% 41.38%, 95% 75.07%, 54.54% 75.07%, 25% 63%, 1.53% 41.38%);
}



.heart-part-ev-0 img{
  clip-path: polygon(5.65% 25%, 31.94% 18.39%, 46.5% 14.72%, 86.77% 46.13%, 75% 61.23%, 64.26% 75%, 64.26% 85.47%, 31.94% 58.16%);
}

.heart-part-ev-1 img{
  clip-path: polygon(16.54% 25.72%, 44.91% 10.12%, 77.06% 13.83%, 86.57% 44.77%, 75% 75%, 39.14% 91.71%, 39.14% 44.77%);
}

.heart-part-ev-2 img{
  clip-path: polygon(18.08% 25%, 32.79% 4.73%, 57.42% 9.23%, 82.53% 30%, 82.53% 53.03%, 78.68% 81.8%, 57.42% 98.52%, 5.38% 59.62%);
}

.heart-part-ev-3 img{
  clip-path: polygon(20.22% 25%, 44.04% 15%, 71.96% 15%, 94.81% 31.03%, 94.81% 51.74%, 76.85% 79.75%, 46.3% 84.57%, 16.95% 94.34%, 7.17% 65%);
}




.show-heart .heart-part {
  animation: showHeartPart 1s forwards;
}

.move-down {
  transform: translate(-50%, -17%);
}

@keyframes showHeartPart {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0) rotate(-30deg);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) rotate(0);
  }
}

.show-heart {
  opacity: 1;
}
.gray { 
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    
    filter: grayscale(100%);
	
    filter: gray;
}

.next-button-container {
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
}

.next-button-container button {
    padding: 12px 36px;
    background-color: white;
    color: #000;
    border: none;
    border-radius: 30px;
    font-size: 1.2rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.next-button-container button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}
</style> 